import { DateFormatter } from "../../Service/Helper/Utils";
import { ProgressTrack } from "../LoadingBar/ProgressTrack";

export const BillingBanner = ({ fups = {}, type, label, id, itemName, mitraName, city, isPaid, totalAmount, paidDate, paidType }) => {
    const isFupExits = !!Object.keys(fups).length

    return (
        <div style={{
            borderRadius: 20, overflow:"hidden", position:"relative",
            background: type==="psb"
            ? "linear-gradient(135deg, #974d1e 0%, #b45309 40%, #ca7616 100%)"
            : "linear-gradient(135deg, #1e3a8a 0%, #2563eb 50%, #0891b2 100%)",
            color:"white", padding:"28px 32px",
        }}>
            {/* decorative orbs */}
            <div
                style={{ position:"absolute", top:"-60px", right:"-40px", width:220, height:220, borderRadius:"50%", background:"rgba(255,255,255,0.06)", pointerEvents:"none" }} />
            <div
                style={{ position:"absolute", bottom:"-50px", left:"30%", width:160, height:160, borderRadius:"50%", background:"rgba(255,255,255,0.04)", pointerEvents:"none" }} />

            <div
                style={{ position:"relative", zIndex:1, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:20 }}>
                {/* Left: identity */}
                <div>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                        <span
                            style={{ background:"rgba(255,255,255,0.18)", backdropFilter:"blur(8px)", border:"1px solid rgba(255,255,255,0.2)", borderRadius:99, padding:"4px 14px", fontSize:12, fontWeight:600 }}>{label}</span>
                        <span style={{ fontFamily:"monospace", fontSize:11, opacity:0.6 }}>{id}</span>
                    </div>
                    <div style={{ fontSize:22, fontWeight:800, marginBottom:4, letterSpacing:"-0.02em" }}>{itemName}</div>
                    <div style={{ opacity:0.75, fontSize:13 }}>{mitraName} · {city}</div>
                </div>

                {/* Right: total + status */}
                <div style={{ textAlign:"right" }}>
                    <div
                        style={{ fontSize:11, opacity:0.65, marginBottom:4, textTransform:"uppercase", letterSpacing:"0.06em" }}>
                        Total Tagihan</div>
                    <div style={{ fontSize:32, fontWeight:900, letterSpacing:"-0.03em", lineHeight:1 }}>{totalAmount}</div>
                    <div style={{ marginTop:8, display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8 }}>
                        <span
                            style={{ background: isPaid ? "rgba(16,185,129,0.25)" : "rgba(239,68,68,0.25)", border: `1px solid ${isPaid?"rgba(16,185,129,0.5)":"rgba(239,68,68,0.5)"}`, borderRadius:99, padding:"4px 12px", fontSize:12, fontWeight:600 }}>
                            {isPaid ? "Lunas" : "Belum Bayar"}
                        </span>
                        {isPaid && paidDate && (
                        <span style={{ opacity:0.7, fontSize:12 }}>{type==="psb"?`via ${paidType} ·
                            `:""}{DateFormatter(paidDate)}</span>
                        )}
                    </div>
                </div>
            </div>

            {!isFupExits
            ? (<></>)
            : (<>
                <ProgressTrack
                min = {fups?.monthlyTotal ?? 0}
                max = {fups?.quota ?? 0}
                isDate = {false}
                isGb = {true}
                isBanner = {true}
                percentText = {"Terpakai"}
                progressText = {"Quota Tersisa"}
                />
            </>)
            }
        </div>
    );
}